










































































































































































































































































































import EngageCampaignInterface from "@/interfaces/engageCampaign.interface";
import { useWebsockets } from "@/libs/websockets";
import { textColorByBackgroundColor } from "@/utils/color";
import { decrypt } from "@/utils/crypto";
// @ts-ignore
import { formatDate } from "@/utils/luxon";
import { resolveInitials } from "@/utils/users";
import overviewRateLimitsBox from "@/views/modules/engage/components/overviewRateLimitsBox.vue";
import { computed, ref } from "@vue/composition-api";
import { BAvatar, BButton, BCol, BLink, BOverlay, BRow, BPopover } from "bootstrap-vue";
import { DateTime } from "luxon";
import engagePopover from "../components/engagePopover.vue";
import overviewRatioDeliveredBox from "../components/overviewRatioDeliveredBox.vue";
import overviewRatioReadBox from "../components/overviewRatioReadBox.vue";
import messagePreview from "../create/components/messagePreview.vue";
import overviewInfoBox from "../create/components/overviewInfoBox.vue";
import stepHeader from "../create/components/stepHeader.vue";
import useCampaigns from "../useCampaigns";
import removeUndeliveredFromList from "../components/removeUndeliveredFromList.vue";
import useContactsLists from "@/composables/useContactsLists";
import { MessageStatusType } from "@/types/messageStatus.type";

export default {
    components: {
        BAvatar,
        BPopover,
        BButton,
        engagePopover,
        stepHeader,
        overviewInfoBox,
        overviewRatioDeliveredBox,
        overviewRatioReadBox,
        overviewRateLimitsBox,
        messagePreview,
        BOverlay,
        BLink,
        BRow,
        BCol,
        removeUndeliveredFromList,
    },
    props: {
        id: {
            // @ts-ignore
            type: Number,
            required: true,
        },
    },
    sockets: {
        socketEvent: async function (socketMessage: { event: string; iv: string }) {
            const wsMessage = decrypt(socketMessage.event, socketMessage.iv);

            // Do not process events that is coming from the origin sender.
            // @ts-ignore
            if (wsMessage.senderId === this.websockets.id) {
                return;
            }

            switch (wsMessage.type) {
                case "engage::messageSent":
                    this.updateDeliveryStats(wsMessage.payload);
                    break;
                case "ENTRY_UPDATE":
                    this.updateDeliveredStatsFromEntry(wsMessage.payload);
                    break;
            }
        },
    },
    // @ts-ignore
    setup(props) {
        const {
            activeCampaign,
            isLoading,
            campaignIsScheduled,
            deliveredStats,
            readStats,
            sentCount,
            fetchActiveCampaign,
            updateDeliveryStats,
            updateDeliveredStatsFromEntry,
        } = useCampaigns();
        const { websockets } = useWebsockets();
        const { contactsList, fetchContactsList } = useContactsLists();
        const sendAt = ref(null);
        const countdown = ref(null);

        fetchActiveCampaign(Number(props.id)).then(() => {
            sendAt.value = DateTime.fromISO(activeCampaign.value?.sendAt);
            countdown.value = sendAt.value.diff(DateTime.now(), ["hours", "minutes"]).toObject();
            // the interval is for the countdown
            if (
                campaignIsScheduled.value &&
                (countdown.value.hours > 0 || countdown.value.minutes > 0 || countdown.value.seconds > 0)
            ) {
                setInterval(() => {
                    countdown.value = sendAt.value.diff(DateTime.now(), ["hours", "minutes", "seconds"]).toObject();
                }, 1000);
            }
            // @ts-ignore
            fetchContactsList(activeCampaign.value.contactListId);
        });

        const optedOutEngageContacts = computed(() => {
            if (activeCampaign.value.contacts.length === 0 || contactsListIds.value?.length === 0) {
                return [];
            }
            return activeCampaign.value.contacts.filter((contact) => contact.contact.allowSystemMessages == false);
        });
        const optedInEngageContacts = computed(() => {
            if (activeCampaign.value.contacts.length === 0 || contactsListIds.value?.length === 0) {
                return [];
            }
            return activeCampaign.value.contacts.filter((contact) => contact.contact.allowSystemMessages == true);
        });
        // DENNIS 2022-10: This should be part of the existing Luxon util.
        // Antoine 2024-03-07 before it was taking and activeCampaign now it take a string
        const formatDatetimeToFull = (date: string): undefined | string => {
            if (!date) {
                return;
            }
            return formatDate(date, DateTime.DATE_FULL) + " - " + formatDate(date, DateTime.TIME_SIMPLE);
        };

        const contactsListIds = computed(() => {
            if (!contactsList.value) {
                return [];
            }
            return contactsList.value.contacts.map((contact) => contact.id);
        });

        const undeliveredEngageContactIds = computed(() => {
            if (activeCampaign.value.contacts.length === 0 || contactsListIds.value?.length === 0) {
                return [];
            }
            return activeCampaign.value.contacts
                .filter(
                    (contact) =>
                        (!contact.entry ||
                            contact.entry.status === MessageStatusType.SENT ||
                            contact.entry.status === MessageStatusType.PENDING ||
                            contact.entry.status === MessageStatusType.DECLINED) &&
                        contactsListIds.value.includes(contact.contactId)
                )
                .map((engageContact) => engageContact.contactId);
        });

        return {
            contactsList,
            websockets,
            activeCampaign,
            campaignIsScheduled,
            isLoading,
            DateTime,
            updateDeliveryStats,
            updateDeliveredStatsFromEntry,
            resolveInitials,
            textColorByBackgroundColor,
            countdown,
            sendAt,
            sentCount,
            deliveredStats,
            readStats,
            undeliveredEngageContactIds,
            optedInEngageContacts,
            optedOutEngageContacts,
            getUserColor: (activeCampaign: EngageCampaignInterface): string =>
                activeCampaign?.createdBy?.teams[0]?.color || "#000000",
            formatDatetimeToFull,
        };
    },
};
